import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsPopupComponent } from '@cabinet/components/settings-popup/settings-popup.component';
import { IdentityModel } from '@core/models/identity.model';
import * as fromRoot from '@core/redux';
import * as AuthActions from '@core/redux/auth/auth.actions';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'ux-user-menu',
  templateUrl: './user-menu.component.html',
  imports: [AvatarComponent, DialogModule],
  standalone: true,
  styleUrls: ['./user-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements OnInit, OnDestroy {
  private store = inject<Store<fromRoot.State>>(Store);
  private router = inject(Router);
  dialog = inject(Dialog);
  @Output() onClose = new EventEmitter<void>();

  user: IdentityModel;
  subscription$: Subscription = new Subscription();

  constructor() {
    this.subscription$.add(this.store.pipe(select(fromRoot.getUser)).subscribe(user => (this.user = user)));
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

  onLogout() {
    this.router.navigate(['/auth/sign-in']);
    this.store.dispatch(new AuthActions.SignOutAction());
  }

  /**
   * Открыть настройки пользователей, форма приглашения
   */
  onOpenSettings() {
    this.onClose.emit();
    this.dialog.open<SettingsPopupComponent>(SettingsPopupComponent, {
      data: {
        tab: 'user',
      },
    });
  }
}
